import { Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { BaseDialogComponent } from '@cumlaude/shared-components-dialogs';
import { FavorietenListComponent } from '../../../favorieten-list/favorieten-list.component';

@Component({
	selector: 'app-favorieten-dialog',
	templateUrl: './favorieten-dialog.component.html',
	imports: [BaseDialogComponent, FavorietenListComponent],
})
export class FavorietenDialogComponent {
	private readonly dialogRef = inject(DialogRef);

	sluiten() {
		this.dialogRef.close();
	}
}
